import { deferTracking, sendGAEvent } from '@noths/polaris-client-google-analytics';

const EVENT_CATEGORY = 'Product reviews';

const sendImpression = (eventAction: string) =>
  deferTracking(() =>
    sendGAEvent({
      event: 'custom_event',
      event_category: EVENT_CATEGORY,
      event_action: eventAction,
      event_label: 'not set',
    }),
  );

export const trackReviewsSummaryImpression = () => sendImpression('Reviews summary impression');

export const trackAiSummaryImpression = () => sendImpression('AI summary impression');

export const trackMostLovedImpression = () => sendImpression('Most Loved impression');
